import React from "react";
import { NotificationToast } from "@ds/ds-snam/react";
//import { DSNotificationPopup } from "@ds/ds-snam";
import useNotification from "hooks/useNotification";
import { INotificationState } from "dataModels/stateModels/notification";

const Notification: React.FC<{}> = (): JSX.Element => {

    const notificationState: INotificationState = useNotification();

    return (
        notificationState.show ? <>
            {/*<ds-overlay-backdrop></ds-overlay-backdrop>*/}
            <NotificationToast
                style={{ position: "fixed", right: "20px",zIndex:100}}
                notification-status={notificationState.status}
                toastTitle={notificationState.title}
                toastDescription={notificationState.description}
                horizontalPosition="right"
                verticalPosition="top"
                top={64}
                right={16}
                zIndex={999}
                textlinkText=""
                textlinkUrl=""
                closeButtonAriaLabel="close toast"
                notificationAriaLabel="notification status aria text"
                notificationTitleId="notification-title"
                isFixed={true}
                toast-size="large"
                isVisible={true}
                onCloseToast={notificationState.onClose}
        /></>
           
            : <></>
    )
}

export default Notification;